// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"74b19108","52":"f83db81b","53":"86b85b00","197":"f481bf45","337":"f0981014","477":"c49ea811","587":"4fd7e8c5"}[chunkId] + ".js";
};